export default __webpack_public_path__ + "static/media/Tendencias-orange.74fa82ee.svg";